import React from 'react';
import {Box, Grid, Typography} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import StarBorderIcon from '@material-ui/icons/StarBorder';
import {withStyles} from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
import {toRound} from "../shared/utils";
import {NO_RESPONSES} from "../shared/Constants";

const StyledRating = withStyles({
    iconFilled: {
        color: '#F2A900',
    }
})(Rating);

export const SummaryRating = ({classes, item, feedbackList}) => {
    const comments = feedbackList.filter(item => item.feedback.comment !== "");
    const responses = feedbackList.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
    const recordedResponses = feedbackList.filter(item => item.feedback.notApplicable === true || item.feedback.declined === true || item.feedback.rating !== "");
    // const averageStarRating = responses.length > 0 && responses.reduce((total, next) => total + parseInt(next.feedback.rating), 0) / responses.length;
    const maxStars = item.responseType.id === 2 ? 5 :
        item.responseType.id === 4 ? item.custLikertRanges.length : 0;

    const custLikertScaleResponses = item.responseType.id === 4 && feedbackList.filter(item => item.feedback.notApplicable === false && item.feedback.rating !== "");
    const custLikertAveragePointRange = custLikertScaleResponses.length > 0 ? (custLikertScaleResponses.reduce((total, next) => total + parseInt(next.feedback.custLikertPointRange), 0) / (custLikertScaleResponses.length * 100)) * 100 : 0;
    const minLikertRangeList = custLikertAveragePointRange > 0 ? item.custLikertRanges.filter(custLikertRange => custLikertRange.pointsRange < custLikertAveragePointRange) : [];
    const minLikertRange = custLikertAveragePointRange > 0 ? minLikertRangeList.at(minLikertRangeList.length - 1) : [];
    const maxLikertRange = custLikertAveragePointRange > 0 ? item.custLikertRanges.filter(custLikertRange => custLikertRange.pointsRange >= custLikertAveragePointRange).at(0) : [];
    const averageStarRating = item.responseType.id === 2 ? responses.length > 0 && responses.reduce((total, next) => total + parseInt(next.feedback.rating), 0) / responses.length :
                                item.responseType.id === 4 ? custLikertScaleResponses.length > 0 && minLikertRange.pointsRange === maxLikertRange.pointsRange ? 1 : minLikertRange.order + (custLikertAveragePointRange - minLikertRange.pointsRange)/(maxLikertRange.pointsRange - minLikertRange.pointsRange) : 0 ;
    return (
        <Grid container>
            <Grid item xs={12} md={10}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{
                        expandIcon: classes.expandIcon,
                        content: classes.content,
                        expanded: classes.expanded
                    }}
                    expandIcon={<ExpandMoreIcon
                        style={{fontSize: '2rem'}}/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography
                                color="primary" size="md">
                                    {item.subCategory ? item.subCategory.description + ' : ' : ''} 
                                    {item.criteria}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography color="tertiary" size="sm">
                                {recordedResponses.length} / {feedbackList.length} Responses, {comments.length} Comments
                            </Typography>
                        </Grid>
                    </Grid>
                </AccordionSummary>
            </Grid>
            <Grid item xs={12} md={2}>
                {responses.length > 0 ?
                    <Box display="flex"
                         justifyContent="flex-end"
                         alignItems="center"
                         p="1rem">
                        <StyledRating
                            defaultValue={toRound(averageStarRating)}
                            emptyIcon={<StarBorderIcon
                                fontSize="inherit"/>}
                            readOnly={true}
                            size="large"
                            precision={0.5}
                            max={maxStars}
                        />
                        <Typography size="md" fontWeight="bold"
                                    component="p"
                                    display="inline">
                            {toRound(averageStarRating)}
                        </Typography>
                    </Box>
                    :
                    <Box display="flex"
                         justifyContent="flex-end"
                         alignItems="center"
                         p="1rem">
                        <Typography size="md" fontWeight="bold"
                                    component="p"
                                    display="inline">
                            {NO_RESPONSES}
                        </Typography>
                    </Box>
                }
            </Grid>
        </Grid>
    )
}